import { useEffect, useState } from "react";
import styles from "./AdminRelatorio.module.css";
import { useTranslation } from "react-i18next";
import api from "../../utils/axios/api";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import AdminSideBar from "../../components/SideBar/SideBar";
import Header from "../../components/Header/Header";
import Footer from "../../components/footer/Footer";
import Seta from "../../assets/SetaDireita.svg";
interface Order {
  addressId: string | null;
  cardId: string | null;
  clientId: string;
  createdAt: string;
  date: string;
  freight: number;
  id: string;
  nfe: string;
  paymentMethod: string;
  price: number;
  profit: number;
  quantity: number;
  status: string;
  storeId: string;
  storeName: string;
  typeDelivery: string;
  updatedAt: string;
  voucherId: string | null;
  fee?: number
}

interface Report {
  client: number;
  entrepeneur: number;
  order: number;
  total_pages: number;
  updatedOrders: Order[];
}

function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState<boolean>(false);

  useEffect(() => {
    const media = window.matchMedia(query);
    if (media.matches !== matches) {
      setMatches(media.matches);
    }

    const listener = () => {
      setMatches(media.matches);
    };

    media.addEventListener("change", listener);
    return () => media.removeEventListener("change", listener);
  }, [matches, query]);

  return matches;
}

export default function Relatorios() {
  const [report, setReport] = useState<Report>();
  const [selectedPage, setSelectedPage] = useState(1);
  const [pages, setPages] = useState<number>(0);
  const isSmallScreen = useMediaQuery("(max-width: 768px)");
  const [mobileMenuActive, setMobileMenuActive] = useState(false);

  const getReport = async (page: number) => {
    try {
      const response = await api.get(`/admin/report`, {
        params: { page: page },
      });
      console.log(response.data)
      setReport(response.data);
      setPages(response.data.total_pages);
    } catch (error) {
      console.error("Erro em buscar relatório");
    }
  };

  useEffect(() => {
    getReport(1);
  }, []);

  function formatDate(isoDate: string): string {
    const date = new Date(isoDate);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  }

  const { t } = useTranslation("translation", { keyPrefix: "adminrelatorio" });
  const columns = [t("loja"), t("data"), t("preco"), t("taxaLucro")];

  const toggleMobileMenu = () => {
    setMobileMenuActive(mobileMenuActive);
  };

  async function handleUserReport() {
    try {
      const response = await api.get('/admin/report/full', {
        responseType: 'blob'
      })

      const blob = new Blob([response.data], { type: "text/csv;charset=utf-8;"})

      const url = URL.createObjectURL(blob)
      const link = document.createElement("a")
      link.href = url

      link.setAttribute('download', 'relatorio-completo.csv')
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(url)
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <>
      <Header
        boxShadow
        toggleMobileMenu={toggleMobileMenu}
        mobileMenuActiveState={mobileMenuActive}
        isSmallScreen={isSmallScreen}
      />
      <main className={styles.mainContainer}>
        <section className={styles.sectionContainer}>
          <div className={styles.caminho}>
            <div className={styles.item}>
              <a href="/">{t("minhaConta")}</a>
            </div>
            <div className={styles.img_seta}>
              <img src={Seta} alt="seta" />
            </div>
            <div className={styles.local}>
              <span>{t("logs")}</span>
            </div>
          </div>

          <div className={styles.tituloContainer}>
            <p className={styles.titulo}>{t("logs")}</p>
            <button onClick={handleUserReport} className={styles.buttonReport}>
              Gerar relatório
            </button>
          </div>
          <div className={styles.texto}>
            <p>
              {t("quantidadeVendas")}
              {report?.order}
            </p>
            <p>
              {t("quantidadeClientes")}
              {report?.client}
            </p>
            <p>
              {t("quantidadeLojistas")}
              {report?.entrepeneur}
            </p>
            <p className={styles.space}>{t("lucro")}</p>
          </div>
          <div className={styles.tableWrapper}>
            <table className={styles.table}>
              <thead>
                <tr>
                  {columns.map((column, key) => (
                    <th
                      key={key}
                      className={column === "Ação" ? styles.action : ""}
                    >
                      {column}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {report &&
                  report.updatedOrders.map((item, key) => (
                    <tr key={key}>
                      <td>{item.storeName}</td>
                      <td>{formatDate(item.date)}</td>
                      <td>{item.price}</td>
                      <td>{item.profit.toFixed(2)} ({item.fee}%)</td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
          <div className={styles.pages}>
            {selectedPage != 1 && (
              <IoIosArrowBack
                className={styles.paginationButton}
                onClick={() => {
                  getReport(selectedPage - 1);
                  setSelectedPage(selectedPage - 1);
                }}
              />
            )}
            {Array.from({ length: pages }, (_, i) => i + 1)
              .filter((item) => {
                // Lógica para mostrar no máximo 7 números
                if (pages <= 7) return true;
                if (item <= 6 || item === pages) return true;
                if (item === selectedPage) return true;
                return false;
              })
              .map((item, key, filteredArray) => {
                const isEllipsis =
                  filteredArray[key + 1] && filteredArray[key + 1] !== item + 1;
                return (
                  <div key={key}>
                    <button
                      onClick={() => {
                        setSelectedPage(item);
                        getReport(item);
                      }}
                      className={
                        item === selectedPage ? styles.selectedPage : ""
                      }
                    >
                      {item}
                    </button>
                    {isEllipsis && <span className={styles.elipsis}>...</span>}
                  </div>
                );
              })}
            {selectedPage != pages && (
              <IoIosArrowForward
                className={styles.paginationButton}
                onClick={() => {
                  getReport(selectedPage + 1);
                  setSelectedPage(selectedPage + 1);
                }}
              />
            )}
          </div>
        </section>
        <aside className={styles.asideContainer}>
          <AdminSideBar />
        </aside>
      </main>
      {!isSmallScreen && <Footer />}
    </>
  );
}
